import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PsTimer extends UcoastEl {
    static htmlSelector = 'ps-timer'
    private endDate: Date
    private timerInterval?: number
    
    // DOM elements
    private daysEl: HTMLElement
    private hoursEl: HTMLElement
    private minutesEl: HTMLElement
    private secondsEl: HTMLElement

    constructor() {
        super()
        
        // Initialize DOM references
        this.daysEl = q.rs('.timer-date .timer-value', this)
        this.hoursEl = q.rs('.timer-hour .timer-value', this)
        this.minutesEl = q.rs('.timer-min .timer-value', this)
        this.secondsEl = q.rs('.timer-sec .timer-value', this)
        
        // Parse date with validation
        this.endDate = this.parseDate(this.dataset.date)
    }

    private parseDate(dateString?: string): Date {
        if (dateString) {
            const parsedDate = new Date(dateString)
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate
            }
        }
        throw new Error('Invalid date format. Please use YYYY-MM-DD')
    }

    override connectedCallback() {
        this.startTimer()
    }

    override disconnectedCallback() {
        this.stopTimer()
    }

    private startTimer() {
        this.updateTimer() // Initial update
        this.timerInterval = window.setInterval(() => this.updateTimer(), 1000)
    }

    private stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval)
        }
    }

    private updateTimer() {
        const now = new Date()
        const diff = this.endDate.getTime() - now.getTime()

        if (diff <= 0) {
            this.stopTimer()
            this.displayExpired()
            return
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        this.daysEl.textContent = this.formatTime(days)
        this.hoursEl.textContent = this.formatTime(hours)
        this.minutesEl.textContent = this.formatTime(minutes)
        this.secondsEl.textContent = this.formatTime(seconds)
    }

    private formatTime(value: number): string {
        return value < 10 ? `0${value}` : `${value}`
    }

    private displayExpired() {
        this.daysEl.textContent = '00'
        this.hoursEl.textContent = '00'
        this.minutesEl.textContent = '00'
        this.secondsEl.textContent = '00'
        
        // Optional: Add expired class or trigger event
        this.classList.add('timer-expired')
        this.closest('.section-password__content')?.querySelector('.password-heading')?.classList.add('hidden')
        this.querySelector('.timer-text')?.classList.add('hidden')
        this.closest('.section-password__content')?.querySelector('.timer-expired-message')?.classList.remove('hidden')
    }
}
